import { render } from "./FairDuels.vue?vue&type=template&id=04efd30d&scoped=true"
import script from "./FairDuels.vue?vue&type=script&lang=js"
export * from "./FairDuels.vue?vue&type=script&lang=js"

import "./FairDuels.vue?vue&type=style&index=0&id=04efd30d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04efd30d"]])

export default __exports__